import { render, staticRenderFns } from "./ItemFiles.vue?vue&type=template&id=097d0022"
import script from "./ItemFiles.vue?vue&type=script&lang=js"
export * from "./ItemFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports